/* globals define */
/*
  Purpose:
    - UI controller for the flyoutDIY on the L1 navigation list.

  Dependencies
    - Mustache
    - jQuery
    - Hoverintent
    - THD Namespace
*/

(function closure(root, factory) {
  /* istanbul ignore else  */
  if (typeof define === 'function' && define.amd) {
    define('header.diyflyout', ['jquery', 'mustache', 'header.data', 'header.analytics', 'header.dropdownmodule', 'hoverIntent'],
      function load(jQuery, Mustache, headerData, headerAnalytics, headerDDFlyout) {
        return factory(root, jQuery, Mustache, headerData, headerAnalytics, headerDDFlyout);
      });
  } else {
    // For non-AMD module, expose this to global (will also be useful for test cases)
    /*eslint-disable*/
    var _hfapp = THD.Utility.Namespace.createNamespace('THD.HFApp');
    _hfapp.flyoutDIY = factory(root, jQuery, Mustache, THD.HFApp.data, THD.HFApp.analytics, THD.HFApp.dropdownflyout, $.hoverIntent);
    /*eslint-enable*/
  }
})(this, function factory(root, $, Mustache, headerData, headerAnalytics, headerDDFlyout) {
  var flyoutDIY = {};
  var privateMethods = {};

  privateMethods.templates = {};

  privateMethods.templates.diylist = headerDDFlyout.templates.diyandhs;

  privateMethods.getFlyoutData = function getFlyoutData() {
    var jsonPath = '/hdus/en_US/DTCCOMNEW/fetch/diyflyout.json';
    var responseDataPromise = headerData.getEtchJSON(jsonPath);

    responseDataPromise.then(function _responseDataPromise(diyData) {
      var htmlContent = Mustache.render(privateMethods.templates.diylist, diyData.diyflyout);

      $('.diyFlyout').html(htmlContent);
    });
  };

  privateMethods.triggerHoverintent = function _triggerHoverIntent() {
    $(this).trigger({
      type: 'hoverintent',
      target: this
    });
  };

  // bind to all the necessary elements
  privateMethods.initialize = function initialize() {
    if (headerData.isDropDown()) {
      // delegate to all the things
      $(document)
        .on('click touchend hoverintent', '.Header3 .ShoppingLinks__link[data-id="diyProjectsIdeas"]', privateMethods.getFlyoutData)
        .hoverIntent({
          selector: '.Header3 .ShoppingLinks__link[data-id="diyProjectsIdeas"]',
          over: privateMethods.triggerHoverintent,
          out: $.noop
        });
      $(document)
        .on('click touchend', '#diyFlyout .content_image a', privateMethods.logInteractionforImg)
        .on('click touchend', '#diyFlyout .cta__text', privateMethods.logInteractionforL2)
        .on('click touchend', '#diyFlyout .diyFlyout__level3link', privateMethods.logInteractionforL3);
    }
  };

  privateMethods.logInteractionforL3 = function _logInteractionforL3() {
    var level2 = $(this).parents('.content').find('.cta__text').text();
    var level3 = $(this).text().toLowerCase();
    return privateMethods.logEventPath('header click', [level2, level3]);
  };

  privateMethods.logInteractionforL2 = function _logInteractionforL2() {
    var level2 = $(this).text().toLowerCase();
    return privateMethods.logEventPath('header click', [level2]);
  };

  privateMethods.logInteractionforImg = function _logInteractionforImg() {
    var level2 = $(this).attr('alt');
    return privateMethods.logEventPath('header click', [level2]);
  };

  privateMethods.logEventPath = function _logEventPath(type, pathArray) {
    // Get header at the beginning, then join them all
    var level1 = $('.Header3 .ShoppingLinks__link[data-id="diyProjectsIdeas"]').text();
    return headerAnalytics.logEvent(type, ['header', level1].concat(pathArray).join('>'));
  };

  /*
   * Public Methods
   */

  flyoutDIY.init = function init() {
    privateMethods.initialize();
    headerData.init();

    return this;
  };

  flyoutDIY.getPrivateMethods = function getPrivateMethods() {
    return privateMethods;
  };

  return flyoutDIY;
});
